function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
// From https://git.forge.lmig.com/projects/UUE/repos/liberty-mutual-design-system/browse/src/Responsive/
// Types from responsivePropBuilder.d.ts have been incorporated, but otherwise the code is unchanged.
// In the future, we'll plan to migrate that code to the monorepo. See GDS-1158.

import defaultThresholdMap from './defaultThresholdMap';
var getCurrentValue = function getCurrentValue(value) {
  return value !== undefined ? value : null;
};
var responsivePropBuilder = function responsivePropBuilder(currentThreshold, props, configuration) {
  var thresholdMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultThresholdMap;
  // get the keys from the map, e.g. ['base', 'sm', 'md', 'lg', 'xl']
  var thresholdKeys = Object.keys(thresholdMap);

  // we are going to filter out larger threshold values because we won't be using them
  var startingIndex = thresholdKeys.indexOf(currentThreshold);

  // we only care about the current threshold and smaller in descending order of size from largest to smallest
  // e.g. ['md', 'sm', 'base'] . This how a typical responsive grid works, the value taken is from the current
  // threshold if provided or the next lowest one with a value if not provided.
  var thresholds = thresholdKeys.slice(0, startingIndex + 1).reverse();

  // only an object can contain responsive values, null is an object also but that's not valid
  // e.g. size={{base: 'h4', md: 'h3'}}
  var propKeys = configuration.propKeys.filter(function (propKey) {
    return _typeof(props[propKey]) === 'object' && props[propKey] !== null;
  });

  // loop through the props that have been found as being responsive and extract an object of name/value pairs
  var translatedValues = propKeys.reduce(function (acc, propKey) {
    var result = null;

    // if there are no breakpoints configured, return the original value
    if (!thresholdKeys.some(function (breakpoint) {
      return Object.prototype.hasOwnProperty.call(props[propKey], breakpoint);
    })) {
      result = props[propKey];
    } else {
      // find the first threshold with a value. That is our value because we reversed them above starting at the
      // current threshold and moving to smaller thresholds
      for (var i = 0; i < thresholds.length; i++) {
        var threshold = thresholds[i];
        result = getCurrentValue(props[propKey][threshold]);
        if (result !== null) {
          // we found a value so break
          break;
        }
      }
    }

    // add the value to the result, if the value was not found it is set to null
    return Object.assign(acc, _defineProperty({}, propKey, result));
  }, {});

  // return the result as an object of name/value pairs
  // e.g {{ size: 'h3' }, {'align': 'center'}}
  return translatedValues;
};
export default responsivePropBuilder;